export { default } from './Logo';

require('./logo.scss');